import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function sectionHtml(sections) {
  if (!sections?.length) {
    return "<p><em>No balances</em></p>";
  }

  return sections
    .map((section) => {
      const rows = section.accounts
        .map(
          (a) => `
        <tr>
          <td class="mono">${a.code}</td>
          <td>${a.name}</td>
          <td class="num">${aed(a.amount)}</td>
        </tr>`,
        )
        .join("");

      return `
      <h3>${section.schedule_name}</h3>
      <table>
        <thead><tr><th>Code</th><th>Account</th><th>Amount</th></tr></thead>
        <tbody>${rows}</tbody>
        <tfoot><tr><th colspan="2">Subtotal</th><th class="num">${aed(section.subtotal)}</th></tr></tfoot>
      </table>`;
    })
    .join("");
}

export async function printBalanceSheet(report, title = "Balance Sheet", options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };
  const company = await resolveReportLetterhead({ branchId: withBranch.branch_id, allBranches: withBranch.all_branches });

  const html = buildReportDocument({
    title,
    company,
    metaHtml: `<div><strong>As at:</strong> ${escapeReportHtml(withBranch.as_of_date)}</div>`,
    bodyHtml: `<h2>Assets</h2>
  ${sectionHtml(withBranch.asset_sections)}
  <h2>Liabilities &amp; Capital</h2>
  ${sectionHtml(withBranch.liability_sections)}
  <table class="summary">
    <tr><th>Total Assets</th><td class="num">${aed(withBranch.total_assets)}</td></tr>
    <tr><th>Total Liabilities</th><td class="num">${aed(withBranch.total_liabilities)}</td></tr>
    <tr><th>Difference</th><td class="num">${aed(withBranch.difference)}</td></tr>
  </table>`,
  });

  return openReportPrint(html);
}
